<template>
  <div class="policy">
    <pdfShow v-if="pdfUrl" :pdfUrl="pdfUrl" />
    <p class="policy-empty" v-else>暂无内容！</p>
  </div>
</template>
<script>
import pdfShow from "@/components/pdfShow";

export default {
  name: "policy",
  components: { pdfShow },
  data() {
    return {
      pdfUrl: this.$route.query && this.$route.query.pdfSrc,
    };
  },
};
</script>
<style scoped>
.policy-empty {
  text-align: center;
  font-size: 18px;
  color: #333;
  padding-top: 60px;
}
.policy {
  height: 100%;
}
</style>
